import React, { FunctionComponent } from 'react';

// components
import { Switcher, Switchee } from 'components/Switcher';
import Chat from 'pages/MerchantPages/Assets/components/LiveLike/Widgets/Chat';

interface Props {
  widget: string;
  closePanel: () => void;
  handleBackToWidgets: (resetForm?: () => void) => void;
}

enum Widgets {
  CHATROOMS = 'chatrooms',
}

const WidgetsContainer: FunctionComponent<Props> = ({ widget, closePanel, handleBackToWidgets }) => (
  <Switcher value={widget}>
    <Switchee value={Widgets.CHATROOMS}>
      <Chat closePanel={closePanel} handleBackToWidgets={handleBackToWidgets} />
    </Switchee>
  </Switcher>
);

export default WidgetsContainer;
